import moment from "moment";
import { clone } from "../features/utils/objClone";
import getFlightOfferPrice from "./Flight/getOfferPrice";
import convertFlightObject from "../features/utils/flight/flightOfferObj";
import { configurations } from "../configurations";
import getFlightSeats from "./Flight/getFlightSeats";
import getSavedTravelers from "./Travelers/getSavedTravelers";
import { lookup } from "country-data";
import axios from "axios";

export const flightDirectionStopsController = (flight, direction = 0) => {
  const segments = flight.directions[direction].length;
  return segments - 1;
};

export const flightGetTimestampController = (flightLocation) => {
  const dateTimeString = `${flightLocation?.date} ${flightLocation?.time}`;
  const timestamp = moment(dateTimeString, "MMM DD YYYY HH:mm").toISOString();
  return timestamp;
};

export const flightCalculateDurationController = (
  startTimestamp,
  endTimestamp
) => {
  const start = moment(startTimestamp);
  const end = moment(endTimestamp);
  // console.log({ startTimestamp, endTimestamp });

  const duration = moment.duration(end.diff(start));

  const hours = duration.hours();
  const minutes = duration.minutes();

  return `${hours}h ${minutes}m`;
};

export const flightFlightDurationSum = (durations = []) => {
  const toMinutes = (s) => {
    if (!s) return 0;
    let total = 0;
    const re = /(\d+(?:\.\d+)?)\s*([dhm])/gi; // handles "1d 2h 30m", "4h", "35m", "2h30m"
    let m;
    while ((m = re.exec(String(s)))) {
      const val = parseFloat(m[1]);
      const unit = m[2].toLowerCase();
      if (!Number.isFinite(val)) continue;
      if (unit === "d") total += Math.round(val * 1440);
      else if (unit === "h") total += Math.round(val * 60);
      else if (unit === "m") total += Math.round(val);
    }
    return total;
  };

  const totalMinutes = (durations || []).reduce(
    (acc, s) => acc + toMinutes(s),
    0
  );

  let mins = totalMinutes;
  const days = Math.floor(mins / 1440);
  mins -= days * 1440;
  const hours = Math.floor(mins / 60);
  mins -= hours * 60;
  const minutes = mins;

  const parts = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  if (minutes || parts.length === 0) parts.push(`${minutes}m`); // show "0m" only if total is 0
  return parts.join(" ");
};

export const flightDirectionDuration = (direction = []) => {
  const out = [];
  if (!Array.isArray(direction) || !direction.length) return out;

  for (let i = 0; i < direction.length; i++) {
    const seg = direction[i];

    // segment flight time (use provided duration; fallback to computed)
    const segDur =
      seg?.duration ||
      flightCalculateDurationController(
        flightGetTimestampController(seg?.departure),
        flightGetTimestampController(seg?.arrival)
      );

    if (segDur) out.push(segDur);

    // layover to next segment
    const next = direction[i + 1];
    if (next) {
      const arriveTs = flightGetTimestampController(seg?.arrival);
      const departTs = flightGetTimestampController(next?.departure);

      // compute layover using your existing util
      const layover = flightCalculateDurationController(arriveTs, departTs);
      if (layover) out.push(layover);
    }
  }

  return flightFlightDurationSum(out);
};

export function convertPriceToNumber(price) {
  if (typeof price !== "string") return price;

  var regex = /^[A-Za-z\s]+/;
  var numericPrice = parseFloat(price.replace(regex, "").replaceAll(",", ""));
  return numericPrice;
}

export async function flightBookingGetPriceController({
  bookingData,
  setOffer,
  qObj,
  setLoading,
  setPriceDiff,
  callback,
  cancelToken,
  setBookingData,
}) {
  const length = qObj?.originDestinations?.length;
  // console.log({ bookingData });
  let flightOffers = clone(
    bookingData.offers?.at(0)?.og || bookingData?.offer?.at(0)?.og
  );
  // let flightOffers = clone(
  //   bookingData.offers?.at(length - 1)?.og ||
  //     bookingData?.offer?.at(length - 1)?.og
  // );
  // if (Array.isArray(bookingData?.offer) && bookingData?.offer?.length === 1) {
  //   flightOffers = bookingData.offer?.at(0)?.og || bookingData?.offer?.at(0);
  // } else {
  //   bookingData.offer?.slice(0, length)?.map((obj, i) => {
  //     try {
  //       flightOffers.directions[i] = obj.directions[i];
  //       // flightOffers.segments[i] = obj.segments[i];
  //     } catch (ex) {
  //       console.log(ex);
  //     }
  //     return true;
  //   });
  // }
  // flightOffers.segments = null;
  // flightOffers.fareRules = null;
  // flightOffers = {
  //   ...flightOffers,
  //   pricingInformation: {
  //     ...flightOffers?.pricingInformation,
  //     price: {
  //       ...flightOffers?.pricingInformation?.price,
  //       totalPrice: "NGN 1,045,736",
  //     },
  //   },
  // };

  // .map(obj => {
  //   let temp = clone(obj);
  //   // temp.directions = [temp.directions[0]]
  //   return temp
  // })
  const req = {
    supplier: flightOffers?.supplier,
    offers: [flightOffers],
  };
  if (qObj.adjustment) req["adjustment"] = qObj.adjustment;

  if (cancelToken?.current) {
    cancelToken.current.cancel("Request canceled due to new input.");
  }

  cancelToken.current = axios.CancelToken.source();

  setLoading(true);
  const res = await getFlightOfferPrice(req, "", cancelToken?.current?.token);
  setLoading(false);
  if (res.return) {
    let data =
      res.data.data?.map((obj) => ({
        ...convertFlightObject(obj),
        og: obj,
      })) || [];

    setBookingData((prev) => ({
      ...prev,
      pricing: res?.data?.data?.at(0),
      pricingFailed: false,
      timestamp: moment().toISOString(),
    }));
    // sessionStorage.setItem(
    //   configurations.sessionStorage.flightBooking,
    //   JSON.stringify({
    //     ...bookingData,
    //     pricing: res.data.data?.at(0),
    //     timestamp: moment().toISOString(),
    //   })
    // );
    callback?.(res.data.data?.at(0));
    setOffer(data);
    const previousPrice =
      convertPriceToNumber(
        bookingData?.pricing?.pricingInformation?.price?.totalPrice
      ) ||
      bookingData?.offers?.at(0)?.totalAmount ||
      0;

    setPriceDiff({
      price: data?.at(0)?.totalAmount,
      change: data?.at(0)?.totalAmount - previousPrice || 0,
    });
    // navigate(`/order/new/flight/book/details/${id}`, { replace: true });
  } else {
    setBookingData((prev) => ({
      ...prev,
      pricing: null,
      pricingFailed: true,
      timestamp: moment().toISOString(),
    }));
    // sessionStorage.setItem(
    //   configurations.sessionStorage.flightBooking,
    //   JSON.stringify({
    //     ...bookingData,
    //     pricing: null,
    //     timestamp: moment().toISOString(),
    //   })
    // );
    setOffer(null);
  }
}

export async function flightBookingSeatMapController({
  offer,
  // bookingData,
  setBookingData,
}) {
  const res = await getFlightSeats({
    offers: [offer],
    supplier: offer?.supplier,
  });
  if (res?.return) {
    setBookingData?.((prev) => ({
      ...prev,
      seatMap: res?.data,
    }));
    // sessionStorage.setItem(
    //   configurations.sessionStorage.flightBooking,
    //   JSON.stringify({ ...bookingData, seatMap: res?.data })
    // );
  }
}

export async function flightBookingSavedTravellersController({ bookingData }) {
  if (bookingData?.travelers?.length) return;
  const res = await getSavedTravelers();
  if (res?.return) {
    sessionStorage.setItem(
      configurations.sessionStorage.flightBooking,
      JSON.stringify({
        ...bookingData,
        travelers: res?.data?.data,
      })
    );
  }
}

export async function flightBookingFetchInsuranceController({
  bookingData,
  setInsurace,
  getFlightPolicies,
}) {
  if (bookingData?.insurance?.length) return;
  const data = bookingData?.pricing || bookingData?.offers?.at(0);

  function getFlightType(destinations) {
    let type = "oneway";
    if (destinations?.length > 1) type = "multicity";
    if (destinations?.length === 2)
      if (
        destinations?.at(0)?.departureLocation ===
        destinations?.at(-1)?.arrivalLocation
      )
        type = "return";

    return type;
  }

  const payload = {
    birthDate: "1985-05-15",
    firstName: "John",
    middleName: "Michael",
    lastName: "Doe",
    email: "john.doe@example.com",
    phone: "1234567890",
    gender: "Male",
    title: "Mr",
    city: "Lagos",
    state: "Lagos",
    passportNumber: "A12345678",
    departure: {
      country: "Nigeria" || data?.directions?.at(0)?.at(0)?.departure?.city,
      // country: getLocationData(data?.directions?.at(0)?.at(0)?.departure?.city)?.country,
      iata: data?.directions?.at(0)?.at(0)?.departure?.location,
    },
    startDate: moment(data?.directions?.at(0)?.at(0)?.departure?.date).format(
      "YYYY-MM-DD"
    ),
    endDate: moment(data?.directions?.at(0)?.at(-1)?.arrival?.date).format(
      "YYYY-MM-DD"
    ),
    purposeOfTravel: "Business",
    isRoundTrip: getFlightType(data?.destinations) === "return",
    numberOfAdults: data?.passengers?.adult?.passengerCount || 1,
    numberOfChildren: data?.passengers?.child?.passengerCount || 0,
    numberOfInfants: data?.passengers?.infant?.passengerCount || 0,
    flights: [],
    baggageAllowance: data?.directions?.at(0)?.at(0)?.baggage,
  };
  data?.directions?.map((segment, i) =>
    segment?.map((obj) =>
      payload.flights.push({
        departureDate: moment(obj?.departure?.date).format("YYYY-MM-DD"),
        arrivalDate: moment(obj?.arrival?.date).format("YYYY-MM-DD"),
        flightNumber: obj?.flightNumber,
        pnr: obj?.pnr || "FEDSAA",
        airline: obj?.airline?.marketing || "ET",
        departureAirport: obj?.departure?.location,
        arrivalAirport: obj?.arrival?.location,
        segmentIndex: i,
      })
    )
  );
  getFlightPolicies?.({
    data: payload,
    callback: (data) => {
      setInsurace?.(
        data?.filter((item) => item?.supplier?.includes("Airhelp"))
      );
    },
  });
}

export const updateFlightBookingData = (data) => {
  sessionStorage.setItem(
    configurations.sessionStorage.flightBooking,
    JSON.stringify(data)
  );
};

export const fligthRouteStringController = (offer) => {
  if (!offer) return "";

  const directions = Array.isArray(offer.directions) ? offer.directions : [];
  const destinations = Array.isArray(offer.destinations)
    ? offer.destinations
    : [];

  // Build legs from directions; use map index to align with destinations
  const legs = directions.map((segments = [], idx) => {
    const first = segments[0] || {};
    const last = segments[segments.length - 1] || {};
    const dest = destinations[idx] || null;

    const fromCity = first?.departure?.city || first?.departure?.location || "";
    const toCity = last?.arrival?.city || last?.arrival?.location || "";

    const fromCode =
      dest?.from ||
      first?.departure?.location ||
      first?.departure?.airportCode ||
      "";
    const toCode =
      dest?.to || last?.arrival?.location || last?.arrival?.airportCode || "";

    return {
      fromCity: fromCity || fromCode || "",
      toCity: toCity || toCode || "",
      fromCode: String(fromCode).toUpperCase(),
      toCode: String(toCode).toUpperCase(),
    };
  });

  // Fallback: if no directions, derive legs from destinations
  if (!legs.length && destinations.length) {
    for (const d of destinations) {
      legs.push({
        fromCity: d?.from || "",
        toCity: d?.to || "",
        fromCode: String(d?.from || "").toUpperCase(),
        toCode: String(d?.to || "").toUpperCase(),
      });
    }
  }

  if (!legs.length) return "";

  // Build display chain: CityA - CityB - CityC ...
  const chain = [legs[0].fromCity, ...legs.map((l) => l.toCity)].filter(
    Boolean
  );
  // Remove accidental duplicates
  const displayChain = chain.filter((c, i) => i === 0 || c !== chain[i - 1]);

  const isOneWay = legs.length === 1;

  // Prefer destinations to detect round trip; fall back to legs
  const roundByDest =
    destinations.length === 2 &&
    String(destinations[0]?.from || "").toUpperCase() ===
      String(destinations[1]?.to || "").toUpperCase() &&
    String(destinations[0]?.to || "").toUpperCase() ===
      String(destinations[1]?.from || "").toUpperCase();

  const roundByLegs =
    legs.length === 2 &&
    legs[0].fromCode === legs[1].toCode &&
    legs[0].toCode === legs[1].fromCode;

  const isRoundTrip = roundByDest || roundByLegs;

  if (isRoundTrip) {
    return `${legs[0].fromCity} - ${legs[0].toCity} (Round trip)`;
  }

  if (isOneWay) {
    return `${legs[0].fromCity} - ${legs[0].toCity}`;
  }

  // Multicity
  return displayChain.join(" - ");
};

export const flightBookingInitializationController = (
  bookingData,
  setBookingData,
  user
) => {
  const offer = bookingData?.pricing || bookingData?.offers?.at(0)?.og;
  if (!offer) return;
  if (bookingData?.passengerData) return;
  // assuming you already have:
  const adult = offer?.pricingInformation?.passengerFares?.adult || {
    passengerCount: 0,
  };
  const child = offer?.pricingInformation?.passengerFares?.child || {
    passengerCount: 0,
  };
  const infant = offer?.pricingInformation?.passengerFares?.infant || {
    passengerCount: 0,
  };

  const passengersFun = () => {
    const toInt = (v) => {
      const n = parseInt(v ?? 0, 10);
      return Number.isFinite(n) && n > 0 ? n : 0;
    };

    const spec = [
      { code: "ADT", count: toInt(adult?.passengerCount) },
      { code: "CHD", count: toInt(child?.passengerCount) },
      { code: "INF", count: toInt(infant?.passengerCount) },
    ];

    return spec.flatMap(({ code, count }) =>
      Array.from({ length: count }, () => ({ type: code }))
    );
  };

  const FIELD_KEYS = [
    "gender",
    "firstName",
    "lastName",
    "nationality",
    "dateOfBirth",
    "passport",
    "expiryDate",
    "frequentFlyerNo",
  ];

  const makeDefaultBoolState = () =>
    FIELD_KEYS.reduce((acc, k) => ((acc[k] = false), acc), {});

  let passengers = (passengersFun?.() || []).map((passenger, idx) => ({
    ...passenger,
    primary: idx === 0,
    gender: "Male",
    firstName: "",
    lastName: "",
    nationality: "",
    dateOfBirth: "",
    passport: "",
    expiryDate: "",
    frequentFlyerNo: "",
    index: idx,
  }));

  let focused = passengers.map(() => ({ ...makeDefaultBoolState() }));
  let errors = passengers.map(() => ({ ...makeDefaultBoolState() }));

  // Contact details initialization
  const email = user?.email;
  const phoneNumber = (user?.phone || "")?.split("-");
  const phone = phoneNumber[1] || "";
  const countryCode = phoneNumber[0]?.length > 4 ? "" : phoneNumber[0];

  const defaultContactData = {
    phone: phone || "",
    email: email || "",
    countryCode: countryCode || "234",
  };
  const defaultContactFlags = { phone: false, email: false };
  const prevContact = bookingData?.passengerData?.contact || {};

  const contact = {
    data: { ...defaultContactData, ...(prevContact.data || {}) },
    focused: { ...defaultContactFlags, ...(prevContact.focused || {}) },
    errors: { ...defaultContactFlags, ...(prevContact.error || {}) },
  };

  // Share details initialization

  const defaultShareData = {
    name: "",
    email: "",
    enabled: false,
    showPrice: false,
  };
  const defaultShareFlags = { name: false, email: false };
  const share = {
    data: defaultShareData,
    focused: defaultShareFlags,
    errors: defaultShareFlags,
  };

  const defaultCreateAccountData = {
    password: "",
    confirmPassword: "",
    enabled: false,
  };
  const defaultCreateAccountFlags = { password: false, confirmPassword: false };
  const createAccount = {
    data: defaultCreateAccountData,
    focused: defaultCreateAccountFlags,
    errors: defaultCreateAccountFlags,
  };

  const markup = {
    variant: "Markup",
    type: "Fixed",
    amount: 0,
    markup: 0,
    total: 0,
  };

  setBookingData({
    ...bookingData,
    passengerData: {
      passengers,
      focused,
      errors,
      contact,
      share,
      markup,
      createAccount,
    },
  });
};

const fields = {
  firstName: {
    label: "First name",
    constraints: ["required", "2char"],
  },
  lastName: {
    label: "Last name",
    constraints: ["required", "2char"],
  },
  passport: {
    label: "Passport",
    constraints: ["required", "2char"],
  },
  dateOfBirth: {
    label: "Date of birth",
    constraints: ["required", "age"],
  },
  expiryDate: {
    label: "Passport expiry date",
    constraints: ["required", "expiry"],
  },
  nationality: {
    label: "Nationality",
    constraints: ["required"],
  },
  email: {
    label: "Email address",
    constraints: ["required", "email"],
  },
  phone: {
    label: "Phone number",
    constraints: ["required", "phone"],
  },
};

const AGE_RULES = {
  ADT: { min: 12, max: Infinity, label: "Adult (12+ years)" },
  CHD: { min: 2, max: 12, label: "Child (2–11 years)" },
  INF: { min: 0, max: 2, label: "Infant (0–1 years)" },
  INS: { min: 0, max: 2, label: "Infant (0–1 years)" },
};

const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

// We'll validate phone by counting digits (E.164 allows up to 15)
const getDigitCount = (s = "") => (s.match(/\d/g) || []).length;

export const validateFlightBookingField = (field, value, supportingField) => {
  const config = fields[field];
  if (!config) return false; // unknown field = no validation
  const rules = config.constraints || [];

  for (const rule of rules) {
    switch (rule) {
      case "required": {
        const v = typeof value === "string" ? value.trim() : value;
        if (v === undefined || v === null || v === "") {
          return `${config.label} is required`;
        }
        break;
      }

      case "2char": {
        const v = typeof value === "string" ? value.trim() : value;
        if (!v || v.length <= 2) {
          return `${config.label} must be more than 2 characters`;
        }
        break;
      }

      case "age": {
        const paxType = supportingField?.type; // expects { type: "ADT" | "CHD" | "INF" }
        if (!paxType || !AGE_RULES[paxType]) {
          // If no type provided, skip age validation silently
          // (or return an error if you prefer strict behavior)
          break;
        }

        const dob = moment(value, moment.ISO_8601, true).isValid()
          ? moment(value)
          : moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", "MM/DD/YYYY"], true);

        if (!dob.isValid()) {
          return `${config.label} is invalid`;
        }

        if (dob.isAfter(moment())) {
          return `${config.label} cannot be in the future`;
        }

        // Precise age in years (floating), so boundaries are exact
        const ageYears = moment().diff(dob, "years", true);
        const { min, max, label } = AGE_RULES[paxType];

        // ADT: age >= 12
        // CHD: 2 <= age < 12
        // INF: 0 <= age < 2
        const inRange =
          ageYears >= min && (max === Infinity ? true : ageYears < max);

        if (!inRange) {
          // Helpful message indicating expected category
          return `${config.label} does not match passenger type. Expected ${label}.`;
        }

        break;
      }

      case "expiry": {
        // Parse expiry date
        const exp = moment(value, moment.ISO_8601, true).isValid()
          ? moment(value)
          : moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", "MM/DD/YYYY"], true);

        if (!exp.isValid()) return `${config.label} is invalid`;

        // Must be at least 6 months from now (inclusive)
        const minExp = moment().add(6, "months").startOf("day");
        if (exp.isBefore(minExp)) {
          return `${config.label} must be at least 6 months from today`;
        }
        break;
      }

      case "email": {
        const v = String(value ?? "").trim();
        const ok = EMAIL_REGEX.test(v);
        if (!ok) {
          return `${config.label} must be a valid email`;
        }
        break;
      }

      case "phone": {
        const v = (value || "").trim();

        const digits = getDigitCount(v);
        if (digits < 7 || digits > 15) {
          return `${config.label} must contain 7–15 digits`;
        }

        if (!/^[\d+\s\-().]+$/.test(v)) {
          return `${config.label} contains invalid characters`;
        }

        // optional: if it starts with "+", ensure next is a digit
        if (v.startsWith("+") && !/^\+\d/.test(v)) {
          return `${config.label} is invalid`;
        }
        break;
      }

      // Add more rules here as needed, e.g. pattern, minLength, etc.
      default:
        break;
    }
  }

  return false; // ✅ no error
};

export const validatePassengerBoolean = (passenger, local) => {
  if (!passenger) return false;
  const requiredFields = local
    ? ["firstName", "lastName", "nationality", "dateOfBirth"]
    : [
        "firstName",
        "lastName",
        "passport",
        "expiryDate",
        "nationality",
        "dateOfBirth",
      ];

  for (const fieldName of requiredFields) {
    const value = passenger[fieldName];
    const error = validateFlightBookingField(fieldName, value, {
      type: passenger.type,
    });
    if (error) {
      return false;
    }
  }

  return true;
};

export const validateFlightContactBoolean = (contact) => {
  const requiredFields = ["phone", "email"];

  for (const fieldName of requiredFields) {
    const value = contact[fieldName];
    const error = validateFlightBookingField(fieldName, value);
    if (error) {
      return false;
    }
  }

  return true;
};

export const validateFlightShareBoolean = (share) => {
  const requiredFields = ["email"];

  for (const fieldName of requiredFields) {
    const value = share[fieldName];
    const error = validateFlightBookingField(fieldName, value);
    if (error) {
      return false;
    }
  }

  return true;
};

export const validateFlightBookingData = (bookingData) => {
  const passengers = bookingData?.passengerData?.passengers || [];
  const prevPassengerErrors = bookingData?.passengerData?.errors || [];
  const contactData = bookingData?.passengerData?.contact?.data || {};
  const prevContactErrors = bookingData?.passengerData?.contact?.errors || {};
  const shareData = bookingData?.passengerData?.share?.data || {};
  const prevShareErrors = bookingData?.passengerData?.share?.errors || {};

  const isFlightLocal = (() => {
    const offer = bookingData?.pricing || bookingData?.offers?.at(0)?.og;
    return offer?.flightType === "Local";
  })();
  // Fields we validate per passenger
  const PASSENGER_FIELDS = isFlightLocal
    ? ["firstName", "lastName", "nationality", "dateOfBirth"]
    : [
        "firstName",
        "lastName",
        "passport",
        "expiryDate",
        "nationality",
        "dateOfBirth",
      ];

  // Contact fields
  const CONTACT_FIELDS = ["phone", "email"];

  // Share fields
  const SHARE_FIELDS = ["email"]; // only email is required if share is enabled

  // --- Validate passengers ---
  const passengerErrors = passengers.map((pax, idx) => {
    const prevErr = prevPassengerErrors[idx] || {};
    const nextErr = { ...prevErr };

    for (const field of PASSENGER_FIELDS) {
      const supporting =
        field === "dateOfBirth" ? { type: pax?.type } : undefined;

      nextErr[field] = validateFlightBookingField(
        field,
        pax?.[field],
        supporting
      );
    }

    return nextErr;
  });

  // --- Validate contact ---
  const contactErrors = { ...prevContactErrors };
  for (const field of CONTACT_FIELDS) {
    contactErrors[field] = validateFlightBookingField(
      field,
      contactData?.[field]
    );
  }

  // --- Validate share (only if enabled) ---
  const shareErrors = { ...prevShareErrors };
  if (shareData?.enabled) {
    for (const field of SHARE_FIELDS) {
      shareErrors[field] = validateFlightBookingField(
        field,
        shareData?.[field]
      );
    }
  } else {
    // if not enabled, clear errors
    for (const field of SHARE_FIELDS) shareErrors[field] = "";
  }

  // --- Error checks ---
  const hasPassengerError = passengerErrors.some((errObj) =>
    Object.values(errObj || {}).some(Boolean)
  );
  const hasContactError = Object.values(contactErrors || {}).some(Boolean);
  const hasShareError = Object.values(shareErrors || {}).some(Boolean);

  const updatedBookingData = {
    ...bookingData,
    passengerData: {
      ...(bookingData?.passengerData || {}),
      errors: passengerErrors,
      contact: {
        ...(bookingData?.passengerData?.contact || {}),
        data: contactData,
        errors: contactErrors,
      },
      share: {
        ...(bookingData?.passengerData?.share || {}),
        data: shareData,
        errors: shareErrors,
      },
    },
  };

  return {
    valid: !(hasPassengerError || hasContactError || hasShareError),
    bookingData: updatedBookingData,
  };
};

const getAlpha2FromDialCode = (dialCode, options = {}) => {
  try {
    if (!dialCode) return "";

    // Normalize: ensure it starts with '+' and strip spaces
    const formatted = `${dialCode}`.trim().replace(/\s+/g, "");
    const withPlus = formatted.startsWith("+") ? formatted : `+${formatted}`;

    // Find all countries that list this dial code
    const matches = lookup.countries({ countryCallingCodes: withPlus }) || [];

    if (!matches.length) return "";

    // If caller provided a preferred list (e.g., ["US", "CA"]) for +1, use it.
    if (options.prefer && Array.isArray(options.prefer)) {
      const preferred = matches.find((c) => options.prefer.includes(c.alpha2));
      if (preferred) return preferred.alpha2;
    }

    // Otherwise return the first match
    return matches[0].alpha2 || "";
  } catch (e) {
    console.error("getAlpha2FromDialCode error:", e);
    return "";
  }
};

export const flightBookingPayloadContruct = (bookingData) => {
  let offer = bookingData?.pricing;
  if (bookingData?.formattedFareRules) {
    offer.formattedFareRules = bookingData.formattedFareRules;
  }
  const isSeatSelected = Boolean(
    bookingData?.passengerData?.passengers?.find((passenger) =>
      passenger?.seat?.find?.((item) => item?.seat)
    )
  );
  const isBaggageSelected = Boolean(
    bookingData?.passengerData?.passengers?.find((passenger) =>
      passenger?.baggage?.find?.((item) => item?.baggage)
    )
  );
  const isServiceSelected = Boolean(
    bookingData?.passengerData?.passengers?.find((passenger) =>
      passenger?.services?.find?.((item) => item?.services?.length)
    )
  );

  const extractNumber = (v) => {
    if (typeof v === "number" && Number.isFinite(v)) return v;
    if (v == null) return 0;
    const m = String(v).match(/-?\d+(?:[.,]\d+)?/);
    return m ? Number(m[0].replace(",", ".")) : 0;
  };

  if (isBaggageSelected) {
    offer = {
      ...offer,
      directions: offer?.directions?.map((direction, index) => {
        return direction?.map((segment) => {
          const passengersThatSelected = bookingData?.passengerData?.passengers
            ?.filter((passenger) =>
              passenger?.baggage?.find(
                (baggage) => baggage?.directionIndex === index
              )
            )
            ?.map((item) => {
              const baggage = item?.baggage?.find(
                (bag) => bag?.directionIndex === index
              );
              return {
                ...(baggage?.baggage || {}),
                quantity: baggage?.baggage?.piece || 1,
                price: convertPriceToNumber(baggage?.baggage?.price),
                weight: extractNumber(baggage?.baggage?.weight) || 23,
                passenger: item?.index + 1,
              };
            });
          if (passengersThatSelected?.length) {
            return {
              ...segment,
              additionalServices: {
                ...(segment?.additionalServices || {}),
                chargeableCheckedBags: passengersThatSelected,
              },
            };
          }
          return segment;
        });
      }),
    };
  }

  if (isServiceSelected) {
    offer = {
      ...offer,
      directions: offer?.directions?.map((direction) =>
        direction?.map((segment) => {
          const passengersThatSelected = bookingData?.passengerData?.passengers
            ?.filter((passenger) =>
              passenger?.services?.find(
                (service) => service?.id === segment?.flightNumber
              )
            )
            ?.map((item) => {
              return item?.services
                ?.find((route) => route?.id === segment?.flightNumber)
                ?.services?.map((service) => ({
                  ...service,
                  passenger: item?.index + 1,
                }));
            });
          if (passengersThatSelected?.length) {
            return {
              ...segment,
              additionalServices: {
                ...(segment?.additionalServices || {}),
                chargeableService: passengersThatSelected,
              },
            };
          }
          return segment;
        })
      ),
    };
  }

  if (isSeatSelected) {
    offer = {
      ...offer,
      directions: offer?.directions?.map((direction) =>
        direction?.map((segment) => {
          const passengersThatSelected = bookingData?.passengerData?.passengers
            ?.filter((passenger) =>
              passenger?.seat?.find(
                (seat) => seat?.id === segment?.flightNumber
              )
            )
            ?.map((item) => {
              const seat = item?.seat?.find(
                (st) => st?.id === segment?.flightNumber
              )?.seat;
              return {
                ref: seat?.ref,
                seatNumber: seat?.number,
                passenger: item?.index + 1,
              };
            });
          if (passengersThatSelected?.length) {
            return {
              ...segment,
              additionalServices: {
                ...(segment?.additionalServices || {}),
                chargeableSeatNumber: passengersThatSelected,
              },
            };
          }
          return segment;
        })
      ),
    };
  }

  const normalizeDate = (date) => {
    if (!date) return "";
    return moment(date, moment.ISO_8601, true).isValid()
      ? moment(date).format("YYYY-MM-DD")
      : moment(new Date(date)).format("YYYY-MM-DD");
  };

  const payload = {
    supplier: bookingData?.pricing?.supplier,
    offers: [offer],
    travelersInfo: bookingData?.passengerData?.passengers?.map((passenger) => {
      const splitPassengerName = (fullName = "") => {
        const parts = fullName.trim().split(/\s+/);
        const firstName = parts[0] || undefined;
        const middleName =
          parts.length > 1
            ? parts.slice(1).join("").trim() || undefined
            : undefined;
        return { firstName, middleName };
      };

      const { firstName, middleName } = splitPassengerName(
        passenger?.firstName
      );

      let birthDate = moment(passenger.dateOfBirth).format("YYYY-MM-DD");

      const passengerDetail = {
        firstName: firstName,
        // middleName: "---",
        lastName: passenger?.lastName,
        birthDate: birthDate,
        gender: passenger?.gender,
        type: passenger?.type,
        phone: [
          {
            countryCode: bookingData?.passengerData?.contact?.data?.countryCode,
            location: getAlpha2FromDialCode(
              bookingData?.passengerData?.contact?.data?.countryCode
            ),
            number: bookingData?.passengerData?.contact?.data?.phone,
          },
        ],
        email: bookingData?.passengerData?.contact?.data?.email,
        document: {
          documentType: "Passport",
          birthPlace: passenger?.nationality,
          issuanceLocation: passenger?.nationality,
          issuanceDate: "2022-11-24",
          number: passenger?.passport,
          expiryDate: normalizeDate(passenger?.expiryDate),
          issuanceCountry: passenger?.nationality,
          validityCountry: passenger?.nationality,
          nationality: passenger?.nationality,
          holder: true,
        },
      };
      if (middleName) {
        passengerDetail.middleName = middleName;
      }
      return passengerDetail;
    }),
  };
  if (bookingData?.passengerData?.appliedMarkup) {
    const markup = bookingData?.passengerData?.appliedMarkup;
    payload.adjustment = {
      type: markup?.variant || "Markup", //Markup, Markdown
      method: markup?.type || "Fixed", //Fixed, Percentage
      adjustment: parseInt(markup?.amount || "0"),
    };
  }
  if (bookingData?.passengerData?.share?.data?.enabled) {
    const share = bookingData?.passengerData?.share?.data;
    payload.share = [
      {
        shareToName: share?.name || "",
        shareToEmail: share?.email || "",
        includePrice: share?.showPrice || false,
      },
    ];
  }
  const insuredPassengers = bookingData?.passengerData?.passengers
    ?.filter((passenger) => passenger?.insurance?.enabled)
    ?.map((passenger) => ({
      ...passenger,
      travellerInfo: payload.travelersInfo[passenger?.index],
    }));
  if (insuredPassengers?.length) {
    const airhelp = bookingData?.insurance?.at(0);
    if (airhelp) {
      const addonPrice = (addon) => {
        return !addon?.radio
          ? addon?.outboundOnly
          : addon?.selectedOption === "round"
          ? addon?.both
          : addon?.selectedOption === "multi-city"
          ? addon?.outboundOnly *
            ((
              addon.multicityOptions?.filter((option) => option?.selected) || []
            )?.length || 1)
          : addon?.oneOfTwo;
      };
      const insurancePrice = (() => {
        const items = [];
        if (!insuredPassengers?.length) return;
        const commonAddons = bookingData?.passengerData?.addons || [];
        items.push((airhelp?.amount || 0) * insuredPassengers?.length);
        for (const addon of commonAddons) {
          items.push((addonPrice(addon) || 0) * insuredPassengers?.length);
        }
        for (const passenger of insuredPassengers) {
          const addons = passenger?.insurance?.addons || [];
          for (const addon of addons) {
            items.push(addonPrice(addon) || 0);
          }
        }
        return items.reduce((acc, current) => {
          return acc + current;
        }, 0);
      })();
      payload.insurancePayable = insurancePrice;
      payload.insuranceBookingRequest = parseFlightInsuranceBookingData({
        insurance: airhelp,
        data: {
          travellers: insuredPassengers,
          addons: bookingData?.passengerData?.addons || [],
        },
      });
    }
  }
  return payload;
};

const parseFlightInsuranceBookingData = ({ data, insurance }) => {
  const ageCategory = (ageBand) => {
    switch (ageBand) {
      case "CHD":
        return "Child";
      case "INF":
        return "Infant";
      default:
        return "Adult";
    }
  };

  const personsInfo = data?.travellers?.map((traveller) => {
    const travellerInfo = {
      firstName: traveller?.travellerInfo?.firstName,
      middleName: traveller?.travellerInfo?.middleName,
      lastName: traveller?.lastName,
      birthDate: traveller?.dateOfBirth,
      ageCategory: ageCategory(traveller?.type),
      passportNumber: traveller?.travellerInfo?.document?.number,
      nextOfKinRelationship: "-----",
      nextOfKinAddress: "-----",
      nextOfKinName: "-----",
      nextOfKinContact: "---",
      preMedical: false,
      medical: null,
      gender: traveller?.gender,
      title: traveller?.gender === "Male" ? "Mr" : "Mrs",
      phone: `${traveller?.travelersInfo?.phone?.at(0)?.countryCode}-${
        traveller?.travelersInfo?.phone?.at(0)?.number
      }`,
      email: traveller?.travellerInfo?.email,
    };

    return travellerInfo;
  });

  let addons =
    data?.travellers?.map(
      (traveler, travellerIndex) =>
        (traveler?.insurance?.addons || [])?.map((addon) => {
          const payloadAddon = {
            addonId: addon?.id,
            personIndex: travellerIndex,
            segmentIndex: addon?.segmentIndex || 0,
            isMulticity: addon?.isMulticity,
            multicityOptions:
              addon?.multicityOptions
                ?.filter((item) => item?.selected)
                ?.map((item) => item?.segmentIndex) || [],
          };

          if (insurance?.req?.baggageAllowance) {
            let baggage = parseInt(
              insurance?.req?.baggageAllowance?.split(" ")[0] || 0
            );
            if (baggage && addon?.id?.includes("luggage")) {
              payloadAddon.pieces = baggage;
            }
          }
          return payloadAddon;
        }) || []
    ) || [];
  const commonAddons = (data?.addons || [])?.map((addon) => {
    const payloadAddon = {
      addonId: addon?.id,
      segmentIndex: addon?.segmentIndex || 0,
      isMulticity: addon?.isMulticity,
      multicityOptions:
        addon?.multicityOptions
          ?.filter((item) => item?.selected)
          ?.map((item) => item?.segmentIndex) || [],
    };

    return payloadAddon;
  });
  addons = [...addons, ...commonAddons];
  let segmentIndexes = Array.from(
    new Set(insurance?.req?.flights?.map((flight) => flight.segmentIndex))
  );

  let addonExtra =
    data?.travellers?.map(
      (traveler) =>
        traveler?.insurance?.addons?.map((addon) => {
          return {
            ...addon,
            ageCategory: traveler?.type,
          };
        }) || []
    ) || [];

  addonExtra = [...addonExtra, ...(data?.addons || [])];

  addons = addons?.flat();
  addons = addons?.map((addon) =>
    addon?.isMulticity
      ? addon?.multicityOptions
          ?.map((segmentIndex) => {
            return { ...addon, segmentIndex };
          })
          .map((item) => {
            delete item?.isMulticity;
            delete item?.multicityOptions;
            return {
              ...item,
            };
          })
      : addon?.segmentIndex === 0
      ? segmentIndexes?.map((segmentIndex) => {
          return { ...addon, segmentIndex };
        })
      : addon
  );
  addons = addons?.flat();
  addonExtra = addonExtra?.flat();

  if (addons?.length) {
    insurance = { ...insurance, addonSelection: addons, addonExtra };
  }

  return {
    ...insurance,
    personsInfo: personsInfo,
    address: "Lagos, abebe st 1000",
    destinationCountry: insurance?.req?.destinationCountry || "South Africa",
    flights: insurance?.req?.flights,
    flexMarkup: data?.flexMarkup || 0,
    purposeOfTravel:
      data?.travellers?.find((traveller) => traveller?.purposeOfTravel)
        ?.purposeOfTravel || "Leisure",
  };
};

export const flightSeatMapHeadersController = (seatMap) => {
  if (!seatMap) return [];
  const items = seatMap?.seatMap?.map((column) => {
    const seat = column.find((st) => Boolean(st))?.number;
    if (!seat) return "";
    return seat[seat.length - 1];
  });
  return items;
};

export const flightCreateSeatMapController = (seatMap) => {
  if (!seatMap) return [];
  const header = flightSeatMapHeadersController(seatMap);

  const seat_map = [
    [
      ...header.map((headerItem) => {
        return { type: "header", value: headerItem, seat: undefined };
      }),
    ],
    ...seatMap.seatMap[0].map((_, colIndex) => {
      return header?.map((header, headerIndex) => {
        const seatRow = seatMap.seatMap.map((row) => row[colIndex]);

        if (!header) {
          const row = seatRow.map((r) => r?.number);
          let corridorValue = row.find((item) => Boolean(item));
          if (corridorValue) corridorValue = corridorValue.slice(0, -1);
          return { type: "corridor", value: corridorValue, seat: undefined };
        }

        return {
          type: "seat",
          value: seatRow[headerIndex]?.number,
          seat: seatRow[headerIndex],
        };
      });
    }),
  ];

  return seat_map.filter((row) => row.find((col) => col.value));
};

export const flightBookingBreakdownController = (
  bookingData,
  type,
  purpose
) => {
  const offer = bookingData?.pricing || bookingData?.offers?.[0]?.og;
  if (!offer) {
    switch (type) {
      case "total":
        return 0;
      default:
        return [];
    }
  }
  const flightTotal = () => {
    if (!offer) return 0;

    const totalStr = offer?.pricingInformation?.price?.totalPrice || "";

    const num = parseFloat(totalStr.replace(/[^\d.]/g, ""));

    return isNaN(num) ? 0 : num;
  };

  const productItems = () => {
    if (!offer) return [];

    const getNum = (str) => {
      const n = parseFloat(String(str || "").replace(/[^\d.]/g, ""));
      return isNaN(n) ? 0 : n;
    };

    const fares = offer?.pricingInformation?.passengerFares || {};
    const order = ["adult", "child", "infant"];
    const labelMap = { adult: "Adult", child: "Child", infant: "Infant" };

    const items = [];
    let baseSum = 0;

    for (const key of order) {
      const f = fares?.[key];
      if (!f?.basePrice) continue;

      const amount = getNum(f.basePrice);
      const count = Number.isFinite(f?.passengerCount) ? f.passengerCount : 1;

      items.push({
        name: `${count} X ${labelMap[key]}`,
        amount,
      });

      baseSum += amount;
    }

    const total = flightTotal();
    const taxes = Math.max(0, total - baseSum);

    baggageProducts(items);
    seatProducts(items);
    insuranceProducts(items);
    additionalProducts(items);

    items.push({
      name: "Taxes and Fees",
      amount: taxes,
    });

    return items;
  };

  const baggageProducts = (items) => {
    const passengerBaggages =
      bookingData?.passengerData?.passengers?.filter((passenger) =>
        passenger?.baggage?.find((baggage) => baggage?.baggage)
      ) || [];
    const travelerLib = {
      ADT: "Adult",
      CHD: "Child",
      INF: "Infant",
    };
    for (const passenger of passengerBaggages) {
      const total = passenger?.baggage?.reduce((acc, current) => {
        return acc + convertPriceToNumber(current?.baggage?.price || "0");
      }, 0);

      items.push({
        name: `${travelerLib[passenger?.type] || "Adult"} ${
          passenger?.index + 1
        } Baggages`,
        amount: total,
        detail: passenger?.baggage
          ?.map((item) => {
            const direction = offer?.directions[item?.directionIndex];
            return {
              name: `${direction?.at(0)?.departure?.city} - ${
                direction?.at(direction?.length - 1)?.departure?.city
              }`,
              amount: item?.baggage?.price
                ? convertPriceToNumber(item?.baggage?.price || "0")
                : 0,
            };
          })
          ?.filter((item) => item?.amount),
      });
    }
  };

  const seatProducts = (items) => {
    const passengerSeats =
      bookingData?.passengerData?.passengers?.filter((passenger) =>
        passenger?.seat?.find((seat) => seat?.seat)
      ) || [];
    const travelerLib = {
      ADT: "Adult",
      CHD: "Child",
      INF: "Infant",
    };
    for (const passenger of passengerSeats) {
      const total = passenger?.seat?.reduce((acc, current) => {
        return acc + convertPriceToNumber(current?.seat?.pricing?.total || "0");
      }, 0);

      items.push({
        name: `${travelerLib[passenger?.type] || "Adult"} ${
          passenger?.index + 1
        } Seat`,
        amount: total,
        detail: passenger?.seat
          ?.map((item) => {
            return {
              name: `${item?.route} (${item?.seat?.number})`,
              amount: item?.seat?.pricing?.total
                ? convertPriceToNumber(item?.seat?.pricing?.total || "0")
                : 0,
            };
          })
          ?.filter((item) => item?.amount),
      });
    }
  };

  const addonPrice = (addon) => {
    return !addon?.radio
      ? addon?.outboundOnly
      : addon?.selectedOption === "round"
      ? addon?.both
      : addon?.selectedOption === "multi-city"
      ? addon?.outboundOnly *
        ((addon.multicityOptions?.filter((option) => option?.selected) || [])
          ?.length || 1)
      : addon?.oneOfTwo;
  };

  const insuranceProducts = (items) => {
    const passengers =
      bookingData?.passengerData?.passengers?.filter(
        (passenger) => passenger?.insurance?.enabled
      ) || [];
    if (!passengers?.length) return;
    const airhelp = bookingData?.insurance?.at(0) || {};
    if (!airhelp) return;
    const commonAddons = bookingData?.passengerData?.addons || [];
    items.push({
      name:
        passengers?.length === 1
          ? "Airhelp basic"
          : `Airhelp basic x ${passengers?.length}`,
      amount: (airhelp?.amount || 0) * passengers?.length,
    });
    for (const addon of commonAddons) {
      items.push({
        name:
          addon?.title +
          (passengers?.length === 1 ? "" : ` x ${passengers?.length}`),
        amount: (addonPrice(addon) || 0) * passengers?.length,
      });
    }
    for (const passenger of passengers) {
      const addons = passenger?.insurance?.addons || [];
      for (const addon of addons) {
        const travelerType = {
          ADT: "Adult",
          CHD: "Child",
          INF: "Infant",
        };
        items.push({
          name:
            addon?.title +
            ` (${travelerType[passenger?.type] || "Adult"} ${
              (passenger?.index || 0) + 1
            })`,
          amount: addonPrice(addon) || 0,
        });
      }
    }
  };

  const additionalProducts = (items) => {
    const passengerServices = (
      bookingData?.passengerData?.passengers?.filter((passenger) =>
        passenger?.services?.find((services) => services?.services?.length)
      ) || []
    )
      ?.flatMap((passenger) => passenger?.services)
      ?.flatMap((route) => route?.services);
    if (passengerServices?.length > 0) {
      const serviceTotal = passengerServices?.reduce((acc, current) => {
        return acc + (convertPriceToNumber(String(current?.price)) || 0);
      }, 0);
      items.push({
        name: "Additional Services",
        amount: serviceTotal,
      });
    }
  };

  const totalAmount = () => {
    if (!offer) return 0;
    return productItems()?.reduce((acc, current) => {
      return acc + current?.amount;
    }, 0);
  };
  let total = totalAmount();

  if (type !== "total") {
    const markup = bookingData?.passengerData?.appliedMarkup;
    if (markup) {
      return [
        ...productItems(),
        {
          name: "Flex markup",
          amount: markup?.markup,
        },
      ];
    }
    return productItems();
  }

  if (purpose === "markup") return total;

  const markup = bookingData?.passengerData?.appliedMarkup;
  if (markup?.markup) total = total + markup?.markup;
  return total;
};

export const flightBookDiabilityParseController = (seatMap) => {
  const services = seatMap?.services || [];
  const wheelchair1 = services?.find((service) =>
    service?.name?.includes("DISABILITY:WCHR")
  );
  const wheelchair2 = services?.find((service) =>
    service?.name?.includes("DISABILITY:WCHS")
  );
  const visual1 = services?.find((service) =>
    service?.name?.includes("DISABILITY:BLND")
  );
  const hearing1 = services?.find((service) =>
    service?.name?.includes("DISABILITY:DEAF")
  );

  const wheelchairOpts = [
    {
      name: "Wheelchair – Stairs OK (WCHR)",
      description:
        "Passenger requires a wheelchair for movement between the terminal and aircraft, but can ascend and descend stairs independently.",
      service: wheelchair1
        ? { ...wheelchair1, code: "DISABILITY:WCHR" }
        : undefined,
    },
    {
      name: "Wheelchair – No Stairs (WCHS)",
      description:
        "Passenger requires a wheelchair for movement between the terminal and aircraft and cannot ascend or descend stairs.",
      service: wheelchair2
        ? { ...wheelchair2, code: "DISABILITY:WCHS" }
        : undefined,
    },
  ];

  const visualAssistanceOpts = [
    {
      name: "Visual Impairment (BLND)",
      description:
        "Passenger has a visual impairment and requires assistance during travel, including guidance through the terminal and to/from the aircraft seat.",
      service: visual1 ? { ...visual1, code: "DISABILITY:BLND" } : undefined,
    },
  ];

  const hearingAssistanceOpts = [
    {
      name: "Hearing Impairment (DEAF)",
      description:
        "Passenger has a hearing impairment and may require special assistance, such as visual boarding cues, written communication, or help understanding announcements.",
      service: hearing1 ? { ...hearing1, code: "DISABILITY:DEAF" } : undefined,
    },
  ];

  const disabilities = [
    {
      name: "Wheelchair",
      options: wheelchairOpts,
      active:
        wheelchairOpts?.filter((item) => Boolean(item.service)).length > 0,
    },
    {
      name: "Visually Impaired",
      options: visualAssistanceOpts,
      active:
        visualAssistanceOpts?.filter((item) => Boolean(item.service)).length >
        0,
    },
    {
      name: "Hearing Difficulties",
      options: hearingAssistanceOpts,
      active:
        hearingAssistanceOpts?.filter((item) => Boolean(item.service)).length >
        0,
    },
  ];

  return disabilities;
};
